import { useLayoutEffect, useState } from "react";
import "./SidebarToggle.css";

const STORAGE_KEY = "riu.sidebarCollapsed";
const BODY_CLASS = "sidebar-collapsed";

const readCollapsed = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
};


export default function SidebarToggle() {
  const [collapsed, setCollapsed] = useState(readCollapsed);

  useLayoutEffect(() => {
    document.body.classList.toggle(BODY_CLASS, collapsed);
    try {
      localStorage.setItem(STORAGE_KEY, collapsed ? "1" : "0");
    } catch { }
    return () => document.body.classList.remove(BODY_CLASS);
  }, [collapsed]);

  return (
    <button
      type="button"
      className="sidebar-toggle"
      aria-label={collapsed ? "Show sidebar" : "Hide sidebar"}
      aria-pressed={collapsed}
      title={collapsed ? "Show sidebar" : "Hide sidebar"}
      onClick={() => setCollapsed((value) => !value)}
    >
      <i className="fas fa-bars" aria-hidden="true" />
    </button>
  );
}
